import { selectColorByScore } from '../../helpers/selectColor.js';

const COMMON_COLOR = {
    darkRed: '#d6464d',
    darkGreen: '#2a945f',
    darkYellow: '#f4d949',
    white: '#ffffff',
}



export const data = (overallScore) => {
    return {
    labels: [],
    datasets: [
        {
            label: '',
            data: [overallScore, 100-overallScore],
            backgroundColor: [selectColorByScore(overallScore),COMMON_COLOR.white],
            borderWidth: 1,
            borderColor: 'rgb(210, 211, 212)'
        }
    ]
}
};


// export const data = (positve, negative, neutral) => {
//     return {
//     labels: [`${positve}% Positive`, `${negative}% Negative`, `${neutral}% Neutral`],
//     datasets: [
//         {
//             label: '',
//             data: [positve, negative, neutral],
//             backgroundColor: [COMMON_COLOR.darkGreen, COMMON_COLOR.darkRed, COMMON_COLOR.darkYellow],
//             borderWidth: 0,
//         }
//     ]
// }
// };